import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Without this, react-router keeps the browser's scroll position across
// route changes, so navigating to a new page can land mid-scroll.
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
